export const localStorageMigrations = {
    0: (state) => {
        return state;
    },
};
